module.exports = __webpack_public_path__ + "img/founder-fallback.f624a21d.jpeg";